'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { BaseIcon } from '../BaseIcon/BaseIcon';
export const Plus = ({ height = '12px', stroke, width = '12px', ...rest }) => {
    const { color } = useTheme();
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: '0 0 12 12', ...rest, children: _jsx("g", { stroke: stroke || color.deprecated.black.primary, strokeWidth: '1.5', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'square', children: _jsx("path", { d: 'M6 1.665v8.92M10.335 6h-8.92' }) }) }));
};
//# sourceMappingURL=Plus.js.map